(() => {
  const sliders = document.querySelectorAll('[data-before-after]');

  sliders.forEach((slider) => {
    const input = slider.querySelector('input[type="range"]');
    if (!input) return;

    const sync = () => {
      slider.style.setProperty('--ba-position', `${input.value}%`);
    };

    input.addEventListener('input', sync);
    sync();
  });

  document.querySelectorAll('[data-mobile-menu-close]').forEach((control) => {
    control.addEventListener('click', () => {
      const details = control.closest('details');
      if (details) details.open = false;
    });
  });
})();
